export const safeLocalStorage = {
  getItem(key) {
    try {
      if (typeof window === 'undefined') return null;
      if (!window.localStorage) return null;
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  },
  setItem(key, value) {
    try {
      if (typeof window === 'undefined') return false;
      if (!window.localStorage) return false;
      window.localStorage.setItem(key, value);
      return true;
    } catch (e) {
      return false;
    }
  },
  removeItem(key) {
    try {
      if (typeof window === 'undefined') return false;
      if (!window.localStorage) return false;
      window.localStorage.removeItem(key);
      return true;
    } catch (e) {
      return false;
    }
  }
};

export function safeParseJson(value, fallback) {
  try {
    if (value == null) return fallback;
    return JSON.parse(value);
  } catch (e) {
    return fallback;
  }
}

